import { Component } from '@angular/core';

@Component({
  selector: 'uni-widget-content-description',
  templateUrl: './uni-widget-content-description.component.html',
  styleUrls: ['./uni-widget-content-description.component.scss'],
})
export class UniWidgetContentDescriptionComponent {
}
